'use client';

import { atom } from 'jotai';

export const snowplowReadyAtom = atom(false);
